import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/NotFoundPage.css';

const NotFoundPage = () => {
  const [randomCardinaux, setRandomCardinaux] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState({});

  // Image de fallback pour les cardinaux sans photo
  const defaultImage = '/images/cardinal-default.png';
  
  useEffect(() => {
    const fetchRandomCardinaux = async () => {
      try {
        // Récupérer tous les cardinaux
        const response = await axios.get('/api/cardinaux');
        const allCardinaux = response.data.cardinaux;
        
        // Sélectionner aléatoirement 8 cardinaux
        const shuffled = [...allCardinaux].sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 8);
        
        setRandomCardinaux(selected);
        setLoading(false);
      } catch (err) {
        console.error("Erreur lors du chargement des cardinaux:", err);
        setLoading(false);
      }
    };
    
    fetchRandomCardinaux();
  }, []);

  // Utiliser la route API pour les images avec le bon content-type
  const getApiImageUrl = (originalUrl, cardinalId) => {
    if (!originalUrl || imageErrors[cardinalId]) return defaultImage;
    
    // Extraire le nom du fichier de l'URL
    const filename = originalUrl.split('/').pop().split('?')[0];
    
    // Ajouter un timestamp pour éviter le cache du navigateur
    const timestamp = new Date().getTime();
    return `/api/images/${filename}?t=${timestamp}`;
  };
  
  // Gestionnaire d'erreur pour les images
  const handleImageError = (cardinalId) => {
    console.log(`Erreur de chargement d'image pour cardinal ${cardinalId}, utilisation de l'image par défaut`);
    setImageErrors(prev => ({
      ...prev,
      [cardinalId]: true
    }));
  };

  // Générer des positions aléatoires pour les photos de cardinaux
  const getRandomPosition = (index) => {
    // Rayon du cercle autour de l'image centrale
    const baseRadius = 150;
    // Angle basé sur l'index pour répartir les images en cercle
    const angle = (index / 8) * 2 * Math.PI;
    
    // Position sur le cercle
    const x = Math.cos(angle) * baseRadius;
    const y = Math.sin(angle) * baseRadius;
    
    return { x, y };
  };

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Non Trouvée</h2>
        
        <div className="not-found-image-container">
          <img 
            src="/images/cardinal-noresult.png" 
            alt="Cardinal confus" 
            className="not-found-image"
            aria-hidden="true"
          />
          
          {!loading && randomCardinaux.map((cardinal, index) => {
            const position = getRandomPosition(index);
            return (
              <Link 
                to={`/cardinaux/${cardinal.slug}`} 
                key={cardinal._id}
                className="floating-cardinal"
                style={{
                  '--x': `${position.x}px`,
                  '--y': `${position.y}px`,
                  '--cardinal-index': index
                }}
                title={cardinal.nomComplet}
              >
                <img 
                  src={getApiImageUrl(cardinal.photo, cardinal._id)} 
                  alt={cardinal.nomComplet} 
                  className="cardinal-mini-photo"
                  onError={() => handleImageError(cardinal._id)}
                />
              </Link>
            );
          })}
        </div>
        
        <p className="not-found-message">
          Désolé, la page que vous cherchez semble avoir disparu dans les couloirs du Vatican.
          <br />
          Peut-être trouverez-vous ce que vous cherchez dans notre annuaire des cardinaux ?
        </p>
        
        <div className="not-found-actions">
          <Link to="/" className="home-button">
            Retour à l'accueil
          </Link>
          <Link to="/cardinaux" className="cardinals-button">
            Parcourir l'annuaire des cardinaux
          </Link>
        </div>
      </div>
      
      <div className="decorative-elements">
        <div className="smoke-left"></div>
        <div className="smoke-right"></div>
      </div>
    </div>
  );
};

export default NotFoundPage;